import { ScaleBand } from "d3-scale";
import { ChartData } from "../interfaces/chart-data";
import {
    LineChartXDomain,
    LineChartTooltipFromatterInputData,
} from "./line-chart";

type DataKey<T> = T extends ScaleBand<string> ? string : Date;

export interface LineChartScaleSpecifics<T> {
    xScale(data: ChartData, width: number): T;

    xAxisEntries(data: ChartData): DataKey<T>[];

    mapValues(
        groupName: string,
        data: ChartData
    ): (k: string) => { key: DataKey<T>; value: number };

    isXLabelTooWide(
        xScale: T,
        maxXTickLabelWidth: number,
        xAxisTicks: T extends ScaleBand<string> ? undefined : LineChartXDomain[]
    );

    closestDataPointFnWith(
        data: ChartData,
        xScale: T,
        offsetX: number,
        selectedGroup: string
    ): (mx: number) => LineChartTooltipFromatterInputData;

    xOffset(xScale: T): number;

    xPositionForKey(xScale: T): (key: DataKey<T>) => number;
}
